import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Collapse, Button } from '@mui/material'
import { ArrowDownward, Home, Map, ViewInAr } from '@mui/icons-material'
import './navigation-drawer.styles.css'

export default function NavigationDrawer() {

    const [checked, setChecked] = React.useState(false);

    return (
        <Box className="navigationDrawerRoot">
            <div onMouseLeave={() => {
                setChecked(() => false);
            }} className="navigationDrawerParent">
                <Collapse in={checked} className="drawerContainer">
                    <Link to="/home">
                        {/* <IconButton color="primary" className="drawerButton"> */}
                        <Button variant="contained" className="drawerButton">
                            <Home />
                        </Button>
                        {/* </IconButton> */}
                    </Link>
                    <Link to="/map">
                        {/* <IconButton color="primary" className="drawerButton"> */}
                        <Button variant="contained" className="drawerButton">
                            <Map />
                        </Button>
                        {/* </IconButton> */}
                    </Link>
                    <Link to="/viewer">
                        {/* <IconButton color="primary" className="drawerButton"> */}
                        <Button variant="contained" className="drawerButton">
                            <ViewInAr />
                        </Button>
                        {/* </IconButton> */}
                    </Link>
                </Collapse>
                <Button variant="contained" className="startDrawerButton"
                    onMouseOver={() => {
                        setChecked(() => true);
                    }}>
                    <ArrowDownward />
                </Button>
            </div>
        </Box>
    )
}
